import * as React from 'react';
import { Price } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { isNil } from '@grandvisionhq/utils';

const ShippingMethodInfo = ({ price , logo , isFree  })=>{
    const { currency , getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "shipping-method-info"
    }, logo, !isFree && !isNil(price) && /*#__PURE__*/ React.createElement(Price, {
        value: price,
        centAmount: true,
        currency: currency,
        className: "shipping-method-info__price"
    }), isFree && /*#__PURE__*/ React.createElement(Text, {
        className: "shipping-method-info__label"
    }, getLabel('common.free')));
};

export { ShippingMethodInfo };
//# sourceMappingURL=ShippingMethodInfo.js.map
